// The player strip invites companies to post until approved jobs arrive. With jobs, the strip opens the list and
// reveals a separate posting link. Both open new tabs, keeping the music playing. The run pauses on hover, focus,
// an idle interface or reduced motion (site/css/app.css).
import { POSTED, loadJobs, tickerJobs, tickerText } from './jobs.js';

const SPEED = 42;                                   // px a second

export function createJobsTicker(strip, url) {
  const link = strip.querySelector('.jobs-main'), run = strip.querySelector('.jobs-track');
  let shown = [];

  const pass = () => shown.map(job => Object.assign(document.createElement('span'), {
    className: job.board === POSTED.id ? 'jobs-item posted' : 'jobs-item', textContent: tickerText(job),
  }));
  // One run is the jobs, repeated until it's as wide as the strip (a job or two would leave it half empty), and the
  // track is that run twice over, so the strip loops without a seam: the animation moves it by one run's width.
  function lay() {
    run.replaceChildren(...pass());
    const room = run.parentElement.clientWidth, width = run.scrollWidth || 1;
    const items = Array.from({ length: Math.max(1, Math.ceil(room / width)) }, pass).flat();
    run.replaceChildren(...items, ...items.map(item => item.cloneNode(true)));
    run.style.setProperty('--jobs-s', `${Math.max(20, run.scrollWidth / 2 / SPEED).toFixed(1)}s`);
  }

  function fill(total) {
    link.href = link.href.replace(/post\/$/, '');                // with jobs on it, the strip opens the list
    link.dataset.contentDestination = 'jobs';
    strip.querySelector('.jobs-tag').textContent = 'Help wanted';
    strip.querySelector('.jobs-all span').textContent = 'See the jobs';
    strip.querySelector('.jobs-post').hidden = false;
    strip.classList.add('running');                             // before measuring: the running strip's own layout
    lay();
    link.setAttribute('aria-label', `Help wanted: ${total} ${total === 1 ? 'job' : 'jobs'}, see them all (opens in a new tab)`);
    // a wider strip (a phone turned sideways) needs more passes to stay full; hidden in Settings it measures nothing, so
    // it is laid again as it comes back
    let queued = 0;
    new ResizeObserver(() => { cancelAnimationFrame(queued); queued = requestAnimationFrame(lay); }).observe(run.parentElement);
  }

  loadJobs(url).then(jobs => {
    shown = tickerJobs(jobs);
    if (shown.length) fill(jobs.length);
  });
}
